import React from 'react';
import DefaultLayout from '../../../layouts/default';

import AddEquipmentHeader from './components/AddEquipmentHeader';
import SidebarInformationPanel from './components/SidebarInformationPanel';
import EquipmentForm from './components/EquipmentForm';
import EquipmentPreviewCard from './components/EquipmentPreviewCard';

function AddEquipmentPage() {
  return (
    <DefaultLayout>
      {/* 1. Global View Wrapper & Layout Header */}
      <div className="w-full flex flex-col min-h-screen bg-slate-50/50">
        <AddEquipmentHeader />

        {/* 2. Main Responsive Content Grid Area */}
        <div className="flex-1 w-full mx-auto">
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
            
            {/* Left Column: Primary 8-Step Input Setup Form */}
            <div className="xl:col-span-8 space-y-6">
              <EquipmentForm />
            </div>

            {/* Right Sticky Sidebar Column: Real-time Live Previews & Meta Guidelines */}
            <div className="xl:col-span-4 flex flex-col gap-6 xl:sticky xl:top-6">
              {/* Dynamic Live Summary Snapshot */}
              <EquipmentPreviewCard />
              
              {/* Reference Documentation & Rules Panel */}
              <SidebarInformationPanel />
            </div>

          </div>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default AddEquipmentPage;
